/* English Language File */

var currentlanguage = 'en';

+function ($) {

	/* English translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				'sProcessing':'Processing...',
				'sLengthMenu':'Entries per page: _MENU_',
				'sZeroRecords':'No matching records found',
				'sInfo':'Showing _START_ to _END_ of _TOTAL_ entries',
				'sInfoEmpty':'Showing 0 to 0 of 0 entries',
				'sInfoFiltered':'(filtered from _MAX_ total entries)',
				'sInfoPostFix':'',
				'sSearch':'Search:',
				'sEmptyTable':'No data available in table',
				'sInfoThousands':',',
				'sLoadingRecords':'Loading...',
				'oPaginate':{
					'sFirst':'First',
					'sLast':'Last',
					'sNext':'Next',
					'sPrevious':'Previous'
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "The credit limit should be between 250k and 150M.",
		grace_holiday_period: "The grace period should be lower than the term in months.",
		term_grace_leasing: "The term minus grace period should always be a multiple of payment frequency.",
		max_term_leasing: "The term minus grace period should not exceed 240 months (20 years).",
		max_term_factoring: "The term should not exceed 1200 months (100 years).",
		net_principal_amount: "The sum of down payment and residual value should be lower than the net principle amount.",
		zero: "This field must be greater than zero."
	});

}(jQuery);
